import {AfterViewInit, Directive, OnDestroy, OnInit} from '@angular/core';

@Directive({
    selector: '[xuiSpeechToText]',
})
export class SpeechToTextDirective implements OnInit, AfterViewInit, OnDestroy {

  constructor() {}

  private sampleRate = 44100;

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }

}
